import "./env.bootstrap";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./shared/store/store";
import { I18nProvider } from "@racoon/i18n";
import { ToastProvider, GlobalErrorToaster } from "@racoon/ui";
import App from "./App";
import { registerSW } from "virtual:pwa-register";
import "@racoon/ui/globals.css";

const updateSW: ((reloadPage?: boolean) => void) | undefined = registerSW({
  immediate: true,
  onNeedRefresh() {
    if (confirm("A new version is available. Update now?")) {
      updateSW?.(true);
    }
  },
  onOfflineReady() {
    console.info("[PWA] App is ready to work offline.");
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <I18nProvider>
        <ToastProvider>
          <GlobalErrorToaster />
          <App />
        </ToastProvider>
      </I18nProvider>
    </Provider>
  </StrictMode>,
);
